export default "__VITE_ASSET__dd7427d7__"